module.exports = {
  /** Additional CSS class names to be added to highlighter elements. */
  'class-name': '',

  /** First line number. */
  'first-line': 1,

  /**
   * Pads line numbers. Possible values are:
   *
   *   false - don't pad line numbers.
   *   true  - automaticaly pad numbers with minimum required number of leading zeroes.
   *   [int] - length up to which pad line numbers.
   */
  'pad-line-numbers': false,

  /** Lines to highlight. */
  'highlight': null,

  /** Title to be displayed above the code block. */
  'title': null,

  /** Enables or disables smart tabs. */
  'smart-tabs': true,

  /** Gets or sets tab size. */
  'tab-size': 4,

  /** Enables or disables gutter. */
  'gutter': true,

  /** Enables quick code copy and paste from double click. */
  'quick-code': true,

  /** Forces code view to be collapsed. */
  'collapse': false,

  /** Enables or disables automatic links. */
  'auto-links': true,

  'unindent': true,

  'html-script': false
};


/** WEBPACK FOOTER **
 ** ./src/defaults.js
 **/